<template>
    <span class="message-square-dashed-icon">
        <svg
            :width="size"
            :height="size"
            viewBox="0 0 24 24"
            fill="none"
            :stroke="stroke"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M14 3h2" />
            <path d="M16 19h-2" />
            <path d="M2 12v-2" />
            <path d="M2 16v5.286a.71.71 0 0 0 1.212.502l1.149-1.149" />
            <path d="M20 19a2 2 0 0 0 2-2v-1" />
            <path d="M22 10v2" />
            <path d="M22 6V5a2 2 0 0 0-2-2" />
            <path d="M4 3a2 2 0 0 0-2 2v1" />
            <path d="M8 19h2" />
            <path d="M8 3h2" />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconMessageSquareDashed',
    props: {
        stroke: {
            type: String,
            default: 'currentColor',
        },
        size: {
            type: [String, Number],
            default: 14,
        },
    },
};
</script>

<style scoped>
/* See IconPlayOutline.vue for why the wrapper needs to be a flex container
   itself: a plain <span> as a flex/grid item doesn't center its own
   inline-level svg content vertically. */
.message-square-dashed-icon {
    display: inline-flex;
    align-items: center;
}
</style>
